import { Box } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";

const ShimmerCell = ({
  flex = 1,
  width,
  height = 12,
  variant = "text",
  delay = 0,
  shimmerGradient,
}) => (
  <Box
    sx={{
      flex: width ? "none" : flex,
      width: width || "auto",
      minWidth: width || 0,
      maxWidth: width ? width : "none",
      height,
      borderRadius:
        variant === "badge" ? "16px" : variant === "checkbox" ? "4px" : "4px",
      background: shimmerGradient,
      backgroundSize: "400% 100%",
      animation: "shimmerWave 2s linear infinite",
      animationDelay: `${delay}ms`,
      "@keyframes shimmerWave": {
        "0%": { backgroundPosition: "100% 0" },
        "100%": { backgroundPosition: "0% 0" },
      },
    }}
  />
);

const TableSkeletonRow = ({ index = 0, shimmerGradient }) => {
  const colors = useColors();
  const effectiveGradient =
    shimmerGradient ||
    `linear-gradient(90deg, ${colors.grey_300} 0%, ${colors.grey_100} 25%, ${colors.grey_300} 50%, ${colors.grey_100} 75%, ${colors.grey_300} 100%)`;
  const baseDelay = index * 90;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        py: "12px",
        px: "16px",
        width: "100%",
        borderBottom: `1px solid ${colors.grey_24percent}`,
      }}
    >
      <ShimmerCell
        width={20}
        height={20}
        variant="checkbox"
        delay={baseDelay}
        shimmerGradient={effectiveGradient}
      />
      <ShimmerCell
        flex={0.8}
        height={14}
        delay={baseDelay + 20}
        shimmerGradient={effectiveGradient}
      />
      <ShimmerCell
        flex={1.5}
        height={14}
        delay={baseDelay + 40}
        shimmerGradient={effectiveGradient}
      />
      <ShimmerCell
        width={56}
        height={24}
        variant="badge"
        delay={baseDelay + 60}
        shimmerGradient={effectiveGradient}
      />
      <ShimmerCell
        flex={1.2}
        height={14}
        delay={baseDelay + 80}
        shimmerGradient={effectiveGradient}
      />
      <ShimmerCell
        flex={1}
        height={14}
        delay={baseDelay + 100}
        shimmerGradient={effectiveGradient}
      />
      <ShimmerCell
        flex={0.8}
        height={14}
        delay={baseDelay + 120}
        shimmerGradient={effectiveGradient}
      />
      <ShimmerCell
        flex={0.6}
        height={14}
        delay={baseDelay + 140}
        shimmerGradient={effectiveGradient}
      />
    </Box>
  );
};

export default TableSkeletonRow;

